import { defaultsDeep } from 'lodash';
import { themeOptionsBase, themeOptionsVariant1, themeOptionsVariant2 } from '@lumahealthhq/ui-core';
import { EThemeKey } from '@lumahealthhq/ui-model-types';
import * as componentsThemeVariant1 from './componentsThemeVariant1';
import * as componentsThemeVariant2 from './componentsThemeVariant2';
export { EThemeKey };
export default function getThemeOptions(themeKey, themeOptions) {
  var defaultThemeOptions = themeOptionsBase;
  switch (themeKey) {
    case EThemeKey.Variant1:
      defaultThemeOptions = defaultsDeep({
        components: componentsThemeVariant1
      }, themeOptionsVariant1);
      break;
    case EThemeKey.Variant2:
      defaultThemeOptions = defaultsDeep({
        components: componentsThemeVariant2
      }, themeOptionsVariant2);
      break;
    case EThemeKey.MaterialUI:
      defaultThemeOptions = {};
      break;
    default:
      break;
  }
  return defaultsDeep({
    themeKey: themeKey
  }, themeOptions, defaultThemeOptions);
}